import $ from 'jquery';
import { getSizedImageUrl } from '@shopify/theme-images';
import { getUrlWithVariant } from '@shopify/theme-product-form';

import { getProductJson } from './../exports/products';
import { getSwatch } from './../exports/get-colors';


export async function gridSwatches(element) {
  var handle = element.getAttribute('data-swatch-handle');
  var label = element.getAttribute('data-swatch-label').trim().toLowerCase();
  var product = await getProductJson(handle);
  var colorOption = product.options.find(function(element) {
    return element.name.toLowerCase() === label || null;
  });

  if (colorOption) {
    var swatches = colorOption.values;
    var swatchElement = document.createElement('fieldset');
    swatchElement.setAttribute('class', 'radio__fieldset radio__fieldset--swatch');
    element.appendChild(swatchElement);
    for (var i = 0; i < swatches.length; i++) {
      var value = swatches[i];
      var swatch = await getSwatch(value);
      var hex = swatch.hex;
      let swatchImage = '';
      if (swatch.path) {
        swatchImage = ` background-image: url('${swatch.path}'); background-size: cover;`;
      }
      var image = '';
      var variant = product.variants.find((variant) => variant.options.includes(value) && variant.featured_media);
      if (typeof variant === 'undefined') {
        variant = product.variants.find((variant) => variant.options.includes(value));
      } else {
        image = variant.featured_media.preview_image.src;
      }
      var variantId = `${variant.id}`;
      var id = `swatch-${variant.id}-${getRandomInt(1, 500)}`;
      var option = `<span class="swatch__button" data-swatch-button data-variant="${variantId}" data-image="${image}">
        <input type="radio" name="options[${label}]" value="${value}" id="${id}">
        <label for="${id}" style="--swatch: ${hex}; ${swatchImage}">
          <span class="visually-hidden">${value}</span>
        </label>
      </span>`;
      swatchElement.innerHTML += option;
    }

    $(element).append(`<div class="radio__fieldset__label">${swatches.length} Colours</div>`);
  }

  return Promise.resolve();
}


export function swatchClicks(container) {
  var $container = $(container);
  var $swatches = $('[data-swatch-button]', $container);
  $swatches.off().click(function() {
    var $swatch = $(this);
    var variant = $swatch.attr('data-variant');
    var image = $swatch.attr('data-image');
    $swatch.closest('[data-grid-item]').find('[data-grid-link]').attr('href', function(i, val) {
      return getUrlWithVariant(val, variant);
    });
    var $imageContainer = $swatch.closest('[data-grid-item]').find('[data-grid-slide]');
    if (image) {
      var width = round180($imageContainer[0].offsetWidth);
      var sizedImage = getSizedImageUrl(image, `${width}x`);
      window.fetch(sizedImage)
        .then(response => {
          return response.blob();
        })
        .then(blob => {
          var objectURL = URL.createObjectURL(blob);
          $imageContainer.css('background-color', '#fff');
          $imageContainer.css('background-image', `url("${objectURL}")`);
          return objectURL;
        })
        .catch(error => {
          console.log(`Error: ${error}`);
        });
    }
  });
}


function round180(x) {
  return Math.ceil(x / 180) * 180;
}

function getRandomInt(minimum, maximum) {
  var min = Math.ceil(minimum);
  var max = Math.floor(maximum);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}


export const swatchSection = {
  onLoad() {
    const swatches = this.container.querySelectorAll('[data-grid-swatches]');
    swatches.forEach(swatch => {
      gridSwatches(swatch).then(() => {
        swatchClicks(swatch);
      });
    });
  },
};
